import { render, staticRenderFns } from "./enterpriseAddress.vue?vue&type=template&id=272e4ca5&"
import script from "./enterpriseAddress.vue?vue&type=script&lang=ts&"
export * from "./enterpriseAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports